// `selectedTables` in localStorage is stored either as an array of table ids
// (single-select flows) or as `{ [tabId]: [tableId, ...] }` (multi-select) -
// this normalizes either shape down to "the table id this dine-in session is for".
export function getSelectedDineInTableId() {
  const raw = localStorage.getItem('selectedTables');
  if (!raw) return null;

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }

  const tables = Array.isArray(parsed) ? parsed : Object.values(parsed || {}).flat();
  return tables[0] ?? null;
}

// Same normalization as getSelectedDineInTableId(), but returns every selected table id
// instead of just the first. Payloads that forward the full selection to the backend -
// e.g. OrdersController::actionOrderCreate's `selected_tables` field - need this shape;
// sending the raw `{ [tabId]: [tableId, ...] }` object straight through breaks that
// endpoint's `implode(',', $selectedTables)`, since implode on a nested array produces the
// literal string "Array" instead of the table id - silently dropping the table association
// (order and its items still save fine, but no table_occupancy row gets created for it).
export function getSelectedTableIds() {
  const raw = localStorage.getItem('selectedTables');
  if (!raw) return [];

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return [];
  }

  return Array.isArray(parsed) ? parsed : Object.values(parsed || {}).flat();
}
